import { Route, Routes, useLocation } from 'react-router-dom'
import { SignIn } from '@/pages/auth/SignIn'
import { SignUp } from '@/pages/auth/SignUp'
import { ConfirmSignUp } from '@/pages/auth/ConfirmSignUp'
import { ForgotPassword } from '@/pages/auth/ForgotPassword'
import { OAuthCallback } from '@/pages/auth/OAuthCallback'
import { SignOut } from '@/pages/auth/SignOut'
import { VerifyEmail } from '@/pages/auth/VerifyEmail'
import { RouteWithTitle } from '@/components/RouteWithTitle'
import { usePageTracking } from '@/hooks/usePageTracking'

export const authRoutes = {
  signin: {
    path: '/signin',
    fullPath: '/auth/signin',
    element: <SignIn />,
    pageTitle: 'Sign In',
  },
  signup: {
    path: '/signup',
    fullPath: '/auth/signup',
    element: <SignUp />,
    pageTitle: 'Sign Up',
  },
  confirmSignUp: {
    path: '/confirm-signup',
    fullPath: '/auth/confirm-signup',
    element: <ConfirmSignUp />,
    pageTitle: 'Confirm Sign Up',
  },
  forgotPassword: {
    path: '/forgot-password',
    fullPath: '/auth/forgot-password',
    element: <ForgotPassword />,
    pageTitle: 'Forgot Password',
  },
  callback: {
    path: '/callback',
    fullPath: '/auth/callback',
    element: <OAuthCallback />,
    pageTitle: 'OAuth Callback',
  },
  signout: {
    path: '/signout',
    fullPath: '/auth/signout',
    element: <SignOut />,
    pageTitle: 'Sign Out',
  },
  verifyEmail: {
    path: '/verify-email',
    fullPath: '/auth/verify-email',
    element: <VerifyEmail />,
    pageTitle: 'Verify Email',
  },
}

export const AuthRoutes = () => {
  usePageTracking()
  const location = useLocation()

  return (
    <RouteWithTitle routeConfigs={authRoutes}>
      <Routes location={location} key={location.pathname}>
        <Route
          path={authRoutes.signin.path}
          element={authRoutes.signin.element}
        />
        <Route
          path={authRoutes.signup.path}
          element={authRoutes.signup.element}
        />
        <Route
          path={authRoutes.confirmSignUp.path}
          element={authRoutes.confirmSignUp.element}
        />
        <Route
          path={authRoutes.forgotPassword.path}
          element={authRoutes.forgotPassword.element}
        />
        <Route
          path={authRoutes.callback.path}
          element={authRoutes.callback.element}
        />
        <Route
          path={authRoutes.signout.path}
          element={authRoutes.signout.element}
        />
        <Route
          path={authRoutes.verifyEmail.path}
          element={authRoutes.verifyEmail.element}
        />
      </Routes>
    </RouteWithTitle>
  )
}
